import React, { useRef } from 'react';

import { hslToHex } from '@/utils/colorConversions';

import { ColorPicker } from '../ColorPicker';

import s from './ColorPreview.module.scss';

type ColorPreviewProps = {
  label: string;
  color: string;
  isEditable?: boolean;
  onColorChange?: (color: string) => void;
  onColorPickerOpen?: (anchor: HTMLElement) => void;
  colorPickerAnchor?: HTMLElement | null;
  onColorPickerClose?: () => void;
  isHexInputVisible?: boolean;
  onHexValueClick?: () => void;
  hexInput?: React.ReactNode;
};

export const ColorPreview: React.FC<ColorPreviewProps> = ({
  label,
  color,
  isEditable = false,
  onColorChange,
  onColorPickerOpen,
  colorPickerAnchor = null,
  onColorPickerClose,
  isHexInputVisible,
  onHexValueClick,
  hexInput,
}) => {
  const colorPreviewRef = useRef<HTMLDivElement>(null);

  const handleColorPreviewClick = () => {
    if (isEditable && colorPreviewRef.current && onColorPickerOpen) {
      onColorPickerOpen(colorPreviewRef.current);
    }
  };

  return (
    <div className={s.color_preview}>
      <span className={s.color_preview__label}>{label}</span>
      <div className={s.color_preview__wrapper}>
        <div
          ref={colorPreviewRef}
          className={s.color_preview__square}
          style={{ backgroundColor: color }}
          onClick={handleColorPreviewClick}
        />
        {isHexInputVisible ? (
          hexInput
        ) : (
          <span className={s.color_preview__hex} onClick={isEditable ? onHexValueClick : undefined}>
            {hslToHex(color)}
          </span>
        )}
      </div>
      {isEditable && onColorChange && (
        <ColorPicker
          open={Boolean(colorPickerAnchor)}
          anchorEl={colorPickerAnchor}
          onClose={onColorPickerClose}
          color={color}
          onChange={onColorChange}
        />
      )}
    </div>
  );
};
